import React from "react";

export function Bullet({ children }) {
  return (
    <li className="flex gap-3">
      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-forest" aria-hidden />
      <span>{children}</span>
    </li>
  );
}
